import { useEffect, useRef } from 'react';
import { useChannel } from 'ably/react';
import withAblyChannel from 'personalization-lib/components/shared/hocs/withAblyChannel';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const AblyChannelProvider = ({
  channelName,
  onMessage,
  children
}) => {
  const onMessageRef = useRef(onMessage);

  // Prevents the callback from triggering the channel to re-subscribe
  useEffect(() => {
    onMessageRef.current = onMessage;
  }, [onMessage]);
  useChannel({
    channelName
  }, message => onMessageRef.current(message));
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default withAblyChannel(AblyChannelProvider);